export default "__VITE_ASSET__49ad0d0a__"